<h2 mat-dialog-title>Edit ANZSIC Code</h2>
<mat-dialog-content>
  <div class="edit-anzsic-dialog-content">
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading industry data...</p>
      </div>
    } @else {
      <form [formGroup]="formGroup">
        <div class="form-field-container">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Primary Industry (Division)</mat-label>
            <mat-select [formControl]="formControlDivision" [compareWith]="compareWithDivision">
              @for (division of divisions; track division.code) {
                <mat-option [value]="division">
                  {{ division.code }} - {{ division.title }}
                </mat-option>
              }
            </mat-select>
            @if (formControlDivision.hasError('required') && formControlDivision.touched) {
              <mat-error>Primary Industry is required</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-field-container">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Industry Sector (Group)</mat-label>
            <mat-select 
              [formControl]="formControlGroup" 
              [compareWith]="compareWithGroup"
              [disabled]="!formControlDivision.value">
              @for (group of groups; track group.code) {
                <mat-option [value]="group">
                  {{ group.code }} - {{ group.title }}
                </mat-option>
              }
            </mat-select>
            @if (formControlGroup.hasError('required') && formControlGroup.touched) {
              <mat-error>Industry Sector is required</mat-error>
            }
            @if (!formControlDivision.value) {
              <mat-hint>Select a Primary Industry first</mat-hint>
            }
          </mat-form-field>
        </div>

        <div class="form-field-container">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Industry Class</mat-label>
            <mat-select 
              [formControl]="formControlClass" 
              [compareWith]="compareWithClass"
              [disabled]="!formControlGroup.value">
              @for (industryClass of classes; track industryClass.code) {
                <mat-option [value]="industryClass">
                  {{ industryClass.code }} - {{ industryClass.title }}
                </mat-option>
              }
            </mat-select>
            @if (formControlClass.hasError('required') && formControlClass.touched) {
              <mat-error>Industry Class is required</mat-error>
            }
            @if (!formControlGroup.value) {
              <mat-hint>Select an Industry Sector first</mat-hint>
            }
          </mat-form-field>
        </div>
      </form>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="isSaving">Cancel</button>
  <button 
    mat-flat-button 
    color="primary" 
    (click)="onSubmit()" 
    [disabled]="!formGroup.valid || isLoading || isSaving">
    @if (isSaving) {
      <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
      Saving...
    } @else {
      Save
    }
  </button>
</mat-dialog-actions>

